import React from "react";
import {Box, Typography} from "@mui/material";
import {EMPTY_UI} from "../variables";

export interface ToolbarEntry {
    name: string;
    value?: React.ReactNode;
}

export interface ToolbarNameValueDataProps {
    data: ToolbarEntry[];
}

export default function ToolbarNameValueData({data}: ToolbarNameValueDataProps) {
    return (
        <Box
            sx={{
                ml: "auto",
                display: "flex",
                flexWrap: "wrap",
                "& .MuiBox-root": {
                    mr: 4,
                },
            }}
        >
            {data.map((nv) => (
                <Box key={nv.name}>
                    <Typography variant="subtitle2">{nv.name}</Typography>
                    <Typography variant="body2">{nv.value || EMPTY_UI}</Typography>
                </Box>
            ))}
        </Box>
    );
}
